<script lang="ts">
    import { _ } from "svelte-i18n";
    import type { ModelLocationInfoManager } from "./ModelLocationInfoManager";
    import Score from "../../Score.svelte";

    export let manager: ModelLocationInfoManager;
    let modelTranslationKeyStore = manager.getModelTranslationKeyStore();
    let selectedLocationStore = manager.getSelectedLocationStore();
    let showCyclingScoreStore = manager.getShowCyclingScoreStore();

    $: if (typeof $selectedLocationStore !== "undefined") {
        safetyScore = Math.round(Number(
            $selectedLocationStore.tags.get("_score:bicycle.commute:safety") ??
                "0",
        ) * 10) / 10;
        tripsDeparting = 0;
        if (typeof $selectedLocationStore.startingTrips !== "undefined") {
            $selectedLocationStore.startingTrips.forEach(t => {
                tripsDeparting += t.trips.length;
            });
        }
        tripsArriving = 0;
        if (typeof $selectedLocationStore.endingTrips !== "undefined") {
            $selectedLocationStore.endingTrips.forEach(t => {
                tripsArriving += t.trips.length;
            });
        }
    }

    let tripsArriving: number = 360;
    let tripsDeparting: number = 360;
    let safetyScore: number = 1.5;
</script>

<div class="card-body p-4">
    <p class="mb-2 small">
        {$_(`${$modelTranslationKeyStore}.location.p1.part1`)} <strong>{tripsArriving}</strong> 
        {$_(`${$modelTranslationKeyStore}.location.p1.part2`)} <strong>{tripsDeparting}</strong> 
        {$_(`${$modelTranslationKeyStore}.location.p1.part3`)}
    </p>
    {#if $showCyclingScoreStore}
    <Score score={safetyScore} class="score-main">
        {safetyScore}
    </Score>
    {/if}
    <p class="mb-2 text-muted small">
        {$_("location.subtitle")}
    </p>
</div>

<style>
    .scores {
        display: grid;
        grid-auto-flow: column;
        grid-template-rows: 100px 120px;
        grid-template-columns: 50% 50%;
        padding: 10px;
        text-align: center;
    }
</style>
